import { handleActions } from "redux-actions";

import { setConfigCiTestCases } from "./actions";

const initialState = {
    isLoadingConfigCiTestCases: false,
    codes: [],
    configCiTestCases: {}
};

export const configCiTestCasesReducer = handleActions(
    {
        [setConfigCiTestCases]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);
